<template>
  <div>
    <CanvasResult
      :anim="table"
      :game-state="gameState"
      :score="score"
      :window-focus="windowFocus"
      @showResult="showResult"
    />
  </div>
</template>

<script>
import CanvasResult from "@/src/components/xocdia/canvas-xd-result.vue";
import DiceResult from "@components/xocdia/dice-result.vue";
import { GAMESTATE } from '@config/constants.js';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CanvasResult,
    // eslint-disable-next-line vue/no-unused-components
    DiceResult
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    round: { type: Number, default: 0 },
    score: { type: Object, default: () => ({})},
    data: { type: Object, default: () => ({})},
    odds: { type: Object, default: () => ({})},
    isHighlightResult: Boolean,
    currentChip: { type: Number, default: 0 },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
    windowFocus: { type: Number, default: 0 },
  },
  data() {
    return {
      isShowResult: false,
    }
  },
  watch: {
    gameState: function(newVal){
      if(newVal !== "RESULTING"){
        this.isShowResult = false;
      }
    },
    // windowFocus: function(newVal, oldVal){
    //   console.log('[xocdia][flip-result][watch] windowFocus', newVal);
    // },
  },
  methods: {
    showResult() {
      this.isShowResult = true;
      console.log('[flip-result] - showResult', this.isShowResult);
    },
    
  }
}
</script>

<style scoped>
.dish-close {
  width: 90%;
  margin-left: 3%;
}

.dish-open {
  width: 80%;
  margin-left: 7%;
  margin-top: 6%;
}
</style>
